import { createContext, useContext, useState } from 'react';

const FiltersCardsContext = createContext();

export const FiltersCardsProvider = ({ children }) => {
  const [productFilters, setProductFilters] = useState(null);
  const [portfolioFilters, setPortfolioFilters] = useState(null);
  const [productCategories, setProductCategories] = useState(null);
  const [projectCategories, setProjectCategories] = useState(null);

  const registerProductFilter = (data) => {
    setProductFilters(data);
  };

  const registerPortfolioFilter = (data) => {
    setPortfolioFilters(data);
  };

  const registerProductCategories = (data) => {
    setProductCategories(data);
  };

  const registerProjectCategories = (data) => {
    setProjectCategories(data);
  };

  const getProductFilter = () => {
    return productFilters;
  };

  const getPortfolioFilter = () => {
    return portfolioFilters;
  };

  const getProductCategories = () => {
    return productCategories;
  };

  const getProjectCategories = () => {
    return projectCategories;
  };

  return (
    <FiltersCardsContext.Provider value={{ 
      registerProductFilter, 
      registerPortfolioFilter, 
      getProductFilter, 
      getPortfolioFilter, 
      registerProductCategories, 
      registerProjectCategories, 
      getProductCategories, 
      getProjectCategories 
    }}>
      {children}
    </FiltersCardsContext.Provider>
  );
};

export const useFiltersCards = () => useContext(FiltersCardsContext);